'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Select, Space, Table, Input } from 'antd';
import dayjs from 'dayjs';
import { fetchAdminSurveys } from '../../cores/api/api-dashboard';
import CreatedDateFilter from '../../dashboard/components/filter/date-filter';
const Option = Select.Option;
const SEX_LABEL_MAP = {
    1: '男性',
    2: '女性'
};
export default function SurveyList() {
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), form = _Form$useForm2[0];
    const _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), dataSource = _useState2[0], setDataSource = _useState2[1];
    const _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), loading = _useState4[0], setLoading = _useState4[1];
    const _useState5 = useState({
        current: 1,
        pageSize: 20,
        total: 0
    }), _useState6 = _slicedToArray(_useState5, 2), pagination = _useState6[0], setPagination = _useState6[1];
    useEffect(() => {
        loadSurveys();
    }, []);
    const loadSurveys = (...args_1) => __awaiter(this, [...args_1], void 0, function* (extraParams = {}) {
        setLoading(true);
        try {
            const res = yield fetchAdminSurveys(_objectSpread({
                page: pagination.current,
                limit: pagination.pageSize
            }, extraParams));
            setDataSource(res.data.surveys);
            setPagination(prev => _objectSpread(_objectSpread({}, prev), {}, {
                total: res.data.pagination.total_count
            }));
        }
        finally {
            setLoading(false);
        }
    });
    const columns = [{
            title: 'ユーザーID',
            dataIndex: 'user_id',
            width: 120,
            render: (_, record) => /*#__PURE__*/ React.createElement("a", {
                href: `/admins/users/${record.user_id}`,
                className: "text-blue-600 hover:underline"
            }, record.user_id)
        }, {
            title: 'メール',
            dataIndex: 'user_email',
            width: 240
        }, {
            title: '性別',
            dataIndex: 'user_sex',
            width: 100,
            render: value => { var _a; return (_a = SEX_LABEL_MAP[value]) !== null && _a !== void 0 ? _a : '-'; }
        }, {
            title: '利用経験',
            dataIndex: 'used_before_title',
            width: 160
        }, {
            title: '知ったきっかけ',
            dataIndex: 'how_to_know_title',
            width: 240
        }, {
            title: '理由',
            dataIndex: 'reason_text',
            ellipsis: true,
            render: value => value || ''
        }, {
            title: '作成日',
            dataIndex: 'created_at',
            width: 200,
            render: value => dayjs(value).format('YYYY-MM-DD HH:mm:ss')
        }];
    const onSearch = values => {
        var _a, _b;
        loadSurveys({
            page: 1,
            email: values.email,
            sex: values.user_sex,
            from_date: ((_a = values.created_date) === null || _a === void 0 ? void 0 : _a.start_date) ? dayjs(values.created_date.start_date).format('YYYY-MM-DD') : undefined,
            to_date: ((_b = values.created_date) === null || _b === void 0 ? void 0 : _b.end_date) ? dayjs(values.created_date.end_date).format('YYYY-MM-DD') : undefined
        });
        setPagination(prev => _objectSpread(_objectSpread({}, prev), {}, {
            current: 1
        }));
    };
    const onReset = () => {
        form.resetFields();
        setPagination(prev => _objectSpread(_objectSpread({}, prev), {}, {
            current: 1
        }));
        loadSurveys({
            page: 1
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "survey-list"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: "mb-6"
    }, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical",
        onFinish: onSearch
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ React.createElement(Space, {
        wrap: true,
        size: "large",
        align: "end"
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        name: "email",
        label: "\u30E1\u30FC\u30EB"
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "\u30E1\u30FC\u30EB",
        style: {
            width: 260
        },
        allowClear: true
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        name: "user_sex",
        label: "\u6027\u5225"
    }, /*#__PURE__*/ React.createElement(Select, {
        allowClear: true,
        placeholder: "\u9078\u629E",
        style: {
            width: 140
        }
    }, Object.entries(SEX_LABEL_MAP).map(([value, label]) => /*#__PURE__*/ React.createElement(Option, {
        key: value,
        value: Number(value)
    }, label)))), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u4F5C\u6210\u65E5",
        name: "created_date"
    }, /*#__PURE__*/ React.createElement(CreatedDateFilter, {
        onChange: value => {
            form.setFieldsValue({
                created_date: value
            });
        }
    })), /*#__PURE__*/ React.createElement(Form.Item, null, /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
        onClick: onReset
    }, "\u30EA\u30BB\u30C3\u30C8"), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        htmlType: "submit"
    }, "\u691C\u7D22"))))))), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Table, {
        columns: columns,
        dataSource: dataSource,
        rowKey: "user_id",
        loading: loading,
        pagination: {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: false,
            onChange: page => {
                setPagination(prev => _objectSpread(_objectSpread({}, prev), {}, {
                    current: page
                }));
                loadSurveys({
                    page
                });
            }
        }
    })));
}
